export const removeLocalStorage = (key: string) => {
  localStorage.removeItem(key);
};
